<template lang="pug">
#app
  .position-fixed.p-1(
    v-if="devAPI !== ''"
    style="background-color: rgba(255, 0, 0, 0.9); z-index: 99999; font-size: 8px; color: white;")
    p.m-0
      | Overwriting API Location to "{{devAPI}}"
      | &nbsp;
      a.text-white(href="#" @click="runDevAPIInstruction"): u ?
      | &nbsp;
      a.text-white(href="#" @click="runDevAPIClear"): u clear
  .d-flex.w-100.h-100
    router-view.main-router

  //- vue-js-modal containers
  v-dialog

</template>

<script>
/* eslint-disable no-console */
import axios from 'axios';
import SideNav from '@/components/SideNav.vue';

export default {
  components: {
    SideNav,
  },
  computed: {
    isAuthenticated() { return this.$store.getters.isAuthenticated; },
  },
  data: () => ({
    // currentRoute: null,
    devAPI: '',
  }),
  created() {
    if (localStorage.getItem('api_overwrite')) {
      this.devAPI = localStorage.getItem('api_overwrite');
    }
    this.$store.dispatch('vuexInitial');
  },
  mounted() {
    this.redirectUserAccrordingToRole();
  },
  watch: {
    $route() {
      // console.log(to);
      this.redirectUserAccrordingToRole();
    },
    isAuthenticated(newVal) {
      if (newVal) {
        axios.defaults.headers.common.Authorization = this.$store.getters.authenticationHeader;
      } else {
        this.$router.push({
          name: 'login',
        });
      }
    },
  },
  methods: {
    runDevAPIInstruction() {
      alert('Run "localStorage.setItem(\'api_overwrite\', \'http://upa-back.test/api/\')". Must contains slash at the end of the string.');
    },
    runDevAPIClear() {
      localStorage.removeItem('api_overwrite');
      window.location.reload();
    },
    redirectUserAccrordingToRole() {
      const USER_ROLE = this.$store.getters.user.role;
      const CURRENT_ROUTE = this.$route.name;
      const SHOULD_REDIRECT = CURRENT_ROUTE !== 'login' && CURRENT_ROUTE.startsWith(USER_ROLE) === false;
      // console.log(USER_ROLE);
      // console.log(CURRENT_ROUTE);
      // console.log(SHOULD_REDIRECT);
      if (SHOULD_REDIRECT === true) {
        if (USER_ROLE) {
          this.$router.push({ name: `${USER_ROLE}.home` });
        } else {
          this.$router.push({ name: 'login' });
        }
      }
    },
  },
};
</script>

<style lang="scss">
@import 'style.scss';

#app {
  width: 100vw;
  height: 100vh;

  .main-router {
    // overflow: scroll;
    flex: 1;
  }
}
</style>
